import { PdfViewer } from 'modules/ats/components/PdfViewer'

import './index.styles.css'
interface Props {
  url: string
  filename: string
  contentType: string
}

export const CurriculumViewer = ({ url, filename, contentType }: Props) => {
  const isPdf = contentType === 'application/pdf'
  const isImage = contentType.startsWith('image/')
  const isVideo = contentType.startsWith('video/')

  return (
    <>
      {isPdf && <PdfViewer url={url} filename={filename} initialScale="page-width" />}

      {isImage && <img src={url} className={'CurriculumViewer_previewImage'} />}

      {isVideo && (
        <video className={'CurriculumViewer_previewVideo'} controls>
          <source src={url} type={contentType} />
        </video>
      )}
    </>
  )
}
